export function CorpID(siteurl : string, mode : string) {
  switch (siteurl)
  {
    case process.env.SITE_URL_TEST :
    {
      switch (mode)
      {
        case "CorpID" :
          return `MM`;
        case "Name" :
          return `(주)웰텍연구소(LOCAL)`;
        case "SName" :
          return `웰텍연구소`;
        default :
          return `MM_L`;
      }
    }
    case process.env.SITE_URL_WT_PRO1 :
    case process.env.SITE_URL_WT_PRO2 :
    {
      switch (mode)
      {
        case "CorpID" :
          return `WT`;
        case "Name" :
          return `(주)웰텍연구소`;
        case "SName" :
          return `웰텍연구소`;
        default :
          return `WT`;
      }
    }
    case process.env.SITE_URL_WT_DEV1 :
    case process.env.SITE_URL_WT_DEV2 :
    {
      switch (mode)
      {
        case "CorpID" :
          return `WT`;
        case "Name" :
          return `(주)웰텍연구소(DEV)`;
        case "SName" :
          return `웰텍연구소(DEV)`;
        default :
          return `WT_D`;
      }
    }
    case process.env.SITE_URL_WT_DEMO :
    {
      switch (mode)
      {
        case "CorpID" :
          return `99`;
        case "Name" :
          return `(주)웰텍연구소(DEMO)`;
        case "SName" :
          return `웰텍연구소(DEMO)`;
        default :
          return `99`;
      }
    }
    case process.env.SITE_URL_MM_PRO1 :
    case process.env.SITE_URL_MM_PRO2 :
    {
      switch (mode)
      {
        case "CorpID" :
          return `MM`;
        case "Name" :
          return `(주)앰앰아이`;
        case "SName" :
          return `앰앰아이`;
        default :
          return `MM`;
      }
    }
    case process.env.SITE_URL_MM_DEV :
    {
      switch (mode)
      {
        case "CorpID" :
          return `MM`;
        case "Name" :
          return `(주)앰앰아이(DEV)`;
        case "SName" :
          return `앰앰아이(DEV)`;
        default :
          return `MM_D`;
      }
    }
    case process.env.SITE_URL_TR_PRO1 :
    case process.env.SITE_URL_TR_PRO2 :
    {
      switch (mode)
      {
        case "CorpID" :
          return `TR`;
        case "Name" :
          return `(주)태룡에스디`;
        case "SName" :
          return `태룡`;
        default :
          return `TR`;
      }
    }
    case process.env.SITE_URL_TR_DEV :
    {
      switch (mode)
      {
        case "CorpID" :
          return `TR`;
        case "Name" :
          return `(주)태룡에스디(DEV)`;
        case "SName" :
          return `태룡(DEV)`;
        default :
          return `TR_D`;
      }
    }
    case process.env.SITE_URL_HY_PRO1 :
    case process.env.SITE_URL_HY_PRO2 :
    {
      switch (mode)
      {
        case "CorpID" :
          return `HY`;
        case "Name" :
          return `(주)한영파트너스`;
        case "SName" :
          return `한영`;
        default :
          return `HY`;
      }
    }
    case process.env.SITE_URL_HY_DEV :
    {
      switch (mode)
      {
        case "CorpID" :
          return `HY`;
        case "Name" :
          return `(주)한영파트너스(DEV)`;
        case "SName" :
          return `한영(DEV)`;
        default :
          return `HY_D`;
      }
    }
    case process.env.SITE_URL_ID_PRO1 :
    case process.env.SITE_URL_ID_PRO2 :
    {
      switch (mode)
      {
        case "CorpID" :
          return `ID`;
        case "Name" :
          return `(주)이데아그룹`;
        case "SName" :
          return `이데아`;
        default :
          return `ID`;
      }
    }
    case process.env.SITE_URL_ID_DEV :
    {
      switch (mode)
      {
        case "CorpID" :
          return `ID`;
        case "Name" :
          return `(주)이데아그룹(DEV)`;
        case "SName" :
          return `이데아(DEV)`;
        default :
          return `ID_D`;
      }
    }
    case process.env.SITE_URL_SH_PRO1 :
    case process.env.SITE_URL_SH_PRO2 :
    {
      switch (mode)
      {
        case "CorpID" :
          return `SH`;
        case "Name" :
          return `(유)송현`;
        case "SName" :
          return `송현`;
        default :
          return `SH`;
      }
    }
    case process.env.SITE_URL_SH_DEV :
    {
      switch (mode)
      {
        case "CorpID" :
          return `SH`;
        case "Name" :
          return `(유)송현(DEV)`;
        case "SName" :
          return `송현(DEV)`;
        default :
          return `SH_D`;
      }
    }
  }
};

/*
  if (mode=="DefaultSLogo"){
    return `${process.env.COMMON_URL}/common/logodownload?corpid=WT&devicetype=W&logotype=2`;
  }
  else if (mode=="DefaultName"){
      return `(주)웰텍연구소`;
  }
  else if (mode=="Logo") {
    switch (window.location.origin){
      case process.env.SITE_URL_MM_PRO :
        return `${process.env.COMMON_URL}/common/logodownload?corpid=MM&devicetype=W&logotype=1`;
      default :
        return `${process.env.COMMON_URL}/common/logodownload?corpid=WT&devicetype=W&logotype=1`;
    }
  }
  else if (mode=="SLogo") {
    switch (window.location.origin){
      case process.env.SITE_URL_MM_PRO :
        return `${process.env.COMMON_URL}/common/logodownload?corpid=MM&devicetype=W&logotype=2`;
      default :
        return `${process.env.COMMON_URL}/common/logodownload?devicetype=W&logotype=2`;
    }
  }
  else if (mode=="ICON") {
    switch (window.location.origin){
      case process.env.SITE_URL_MM_PRO :
        return `${process.env.COMMON_URL}/common/logodownload?corpid=MM&devicetype=W&logotype=3`;
      default :
        return `${process.env.COMMON_URL}/common/logodownload?devicetype=W&logotype=3`;
    }
  }
  else if (mode=="SName") {
    switch (window.location.origin) {
    case process.env.SITE_URL_MM_PRO :
      return `앰앰아이`;
    case process.env.SITE_URL_TEST :
      return `개발용`;
    case process.env.SITE_URL_WT_DEMO :
      return `웰텍연구소(DEMO)`;
    case process.env.SITE_URL_WT_DEV :
      return `웰텍연구소(DEV)`;
    default :
      return `웰텍연구소`;
    }
  }
  else if (mode=="Name") {
    switch (window.location.origin) {
    case process.env.SITE_URL_MM_PRO :
      return `(주)앰앰아이`;
    case process.env.SITE_URL_TEST :
      return `개발용`;
    case process.env.SITE_URL_WT_DEMO :
      return `(주)웰텍연구소(DEMO)`;
    case process.env.SITE_URL_WT_DEV :
      return `(주)웰텍연구소(DEV)`;
    default :
      return `(주)웰텍연구소`;
    }
  }
*/